import React from 'react';
import master from '../../assets/master.png';
import amercanexp from '../../assets/americanexp.png';

const PaymentMethod = ({ pm_type, pm_last_four, user_name }) => {
  const cardLogos = {
    visa: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Visa_Inc._logo.svg/2560px-Visa_Inc._logo.svg.png",
    discover: "https://www.discover.com/company/images/newsroom/media-downloads/discover.png",
    jcb: "https://upload.wikimedia.org/wikipedia/commons/e/ed/JCB_logo.svg",
    dinersClub: "https://www.discover.com/company/images/newsroom/media-downloads/diners-club.png",
  };

  const getCardLogo = () => {
    if (pm_type === 'visa') return cardLogos.visa;
    if (pm_type === 'mastercard') return master;
    if (pm_type === 'amex') return amercanexp;
    if (pm_type === 'discover') return cardLogos.discover;
    return amercanexp; // Default fallback
  };

  return (
    <div className="flex items-center justify-between p-4 bg-blue-50 rounded-lg shadow mb-4">
      <div className="flex items-center">
        <div className="mr-4">
          <img
            src={getCardLogo()}
            alt={pm_type}
            className="w-10 h-8 object-contain"
          />
        </div>

        <div>
          <h3 className="text-lg font-semibold text-gray-900">{user_name}</h3>
          <p className="text-sm text-gray-600">**** {pm_last_four}</p>
        </div>
      </div>

      <div className="flex items-center">
        <span className="text-sm font-medium text-blue-600 bg-blue-100 px-2 py-1 rounded-lg mr-4">
          Primary
        </span>
        <span className="w-6 h-6 bg-blue-600 text-white flex items-center justify-center rounded-full">
          ✓
        </span>
      </div>
    </div>
  );
};

export default PaymentMethod; 